import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Image from "mui-image";
import icon1 from "../../../assets/stack-icon-1.svg";
import icon2 from "../../../assets/stack-icon-2.svg";
import icon3 from "../../../assets/stack-icon-3.svg";
import nextIcon from "../../../assets/card-next-arrow.svg";

const OutSourcingPartner = () => {
  const boxStyles = {
    padding: "26px 30px 26px 35px",
    borderRadius: "3px",
    boxShadow: "rgba(0, 0, 0, 0.063) 0px 0px 10px",
    backgroundColor: "rgb(255, 255, 255)",
    color: "rgb(61, 61, 61)",
    transition: "all 0.3s ease-in-out 0s",
    width: "100%",
    textDecoration: "none",
  };
  return (
    <section id="outSourcingPartner" style={{ backgroundColor: "#ffffff" }}>
      <Container
        maxWidth="lg"
        sx={{ padding: { xs: "40px 0", sm: "40px 0", md: "130px 0" } }}
      >
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid item xs={12} md={12}>
              <Typography
                variant="h3"
                gutterBottom
                sx={{ textAlign: { xs: "center", sm: "center", md: "left" } }}
              >
                Your Full-Stack IT{" "}
                <span className="highlight-head">Outsourcing Partner</span>
              </Typography>
              <Typography
                variant="body1"
                gutterBottom
                sx={{
                  textAlign: { xs: "center", sm: "center", md: "left" },
                  mb: 3.7,
                  lineHeight: 1.55,
                  letterSpacing: "-0.14px",
                }}
              >
                Our culture aligns well with yours – agile in mind, spirit, and
                speed.
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={3} sx={{ margin: "50px 0 0" }}>
            <Link
              href="#"
              className="LinkHover"
              sx={boxStyles}
              style={{ marginBottom: "20px" }}
            >
              <Grid item xs={12} md={12}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      borderRight: {
                        xs: "none",
                        md: "1px solid rgba(0, 0, 0, 0.08)",
                      },
                      width: "26%",
                      flexWrap: { sm: "wrap", xs: "wrap", md: "nowrap" },
                      justifyContent: { xs: "center", sm: "center" },
                    }}
                  >
                    <Image src={icon1} width="30%" />
                    <Typography
                      variant="h5"
                      sx={{
                        fontSize: { xs: "1rem", sm: "1rem", md: "1.5rem" },
                        lineHeight: "30px",
                        margin: "0 5px",
                        padding: "0 13px",
                      }}
                    >
                      Managed Agile Teams
                    </Typography>
                  </Box>
                  <Box sx={{ width: "72%" }}>
                    <Typography
                      variant="body2"
                      component="p"
                      sx={{
                        fontSize: "17px",
                        lineHeight: "26px",
                        letterSpacing: "-0.12px",
                        margin: 0,
                        padding: "0 25px",
                        color: "rgb(61, 61, 61)",
                      }}
                    >
                      Our engagement model of remote agile teams has been built
                      and refined over a long period of time. You don’t just get
                      vetted engineers but a proven and transparent process with
                      a successful track record. They immerse themselves in your
                      project, maintaining your company culture and working in
                      line with your strategic goals.
                    </Typography>
                  </Box>
                  <Box sx={{ width: "2%" }}>
                    <Image src={nextIcon} width="20px" className="nextIcon" />
                  </Box>
                </Box>
              </Grid>
            </Link>
            <Link
              href="#"
              className="LinkHover"
              sx={boxStyles}
              style={{ marginBottom: "20px" }}
            >
              <Grid item xs={12} md={12}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      borderRight: "1px solid rgba(0, 0, 0, 0.08)",
                      width: "26%",
                      flexWrap: { sm: "wrap", xs: "wrap", md: "nowrap" },
                      justifyContent: { xs: "center", sm: "center" },
                    }}
                  >
                    <Image src={icon2} width="40%" />
                    <Typography
                      variant="h5"
                      sx={{
                        fontSize: { xs: "1rem", sm: "1rem", md: "1.5rem" },
                        lineHeight: "30px",
                        margin: "0 5px",
                        padding: "0 13px",
                      }}
                    >
                      Complex Core Development
                    </Typography>
                  </Box>
                  <Box sx={{ width: "72%" }}>
                    <Typography
                      variant="body2"
                      component="p"
                      sx={{
                        fontSize: "17px",
                        lineHeight: "26px",
                        letterSpacing: "-0.12px",
                        margin: 0,
                        padding: "0 25px",
                        color: "rgb(61, 61, 61)",
                      }}
                    >
                      Our engagement model of remote agile teams has been built
                      and refined over a long period of time. You don’t just get
                      vetted engineers but a proven and transparent process with
                      a successful track record. They immerse themselves in your
                      project, maintaining your company culture and working in
                      line with your strategic goals.
                    </Typography>
                  </Box>
                  <Box sx={{ width: "2%" }}>
                    <Image src={nextIcon} width="20px" className="nextIcon" />
                  </Box>
                </Box>
              </Grid>
            </Link>
            <Link href="#" className="LinkHover" sx={boxStyles}>
              <Grid item xs={12} md={12}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      borderRight: "1px solid rgba(0, 0, 0, 0.08)",
                      width: "26%",
                      flexWrap: { sm: "wrap", xs: "wrap", md: "nowrap" },
                      justifyContent: { xs: "center", sm: "center" },
                    }}
                  >
                    <Image src={icon3} width="30%" />
                    <Typography
                      variant="h5"
                      sx={{
                        fontSize: { xs: "1rem", sm: "1rem", md: "1.5rem" },
                        lineHeight: "30px",
                        margin: "0 5px",
                        padding: "0 13px",
                      }}
                    >
                      Scale Without Limits
                    </Typography>
                  </Box>
                  <Box sx={{ width: "72%" }}>
                    <Typography
                      variant="body2"
                      component="p"
                      sx={{
                        fontSize: "17px",
                        lineHeight: "26px",
                        letterSpacing: "-0.12px",
                        margin: 0,
                        padding: "0 25px",
                        color: "rgb(61, 61, 61)",
                      }}
                    >
                      Our engagement model of remote agile teams has been built
                      and refined over a long period of time. You don’t just get
                      vetted engineers but a proven and transparent process with
                      a successful track record. They immerse themselves in your
                      project, maintaining your company culture and working in
                      line with your strategic goals.
                    </Typography>
                  </Box>
                  <Box sx={{ width: "2%" }}>
                    <Image src={nextIcon} width="20px" className="nextIcon" />
                  </Box>
                </Box>
              </Grid>
            </Link>
          </Grid>
        </Box>
      </Container>
    </section>
  );
};

export default OutSourcingPartner;
